export function scroll (id) {
    const yOffset = id === 'studio' ? -150 : 0;
    const element = document.getElementById(id);
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({top: y, behavior: 'smooth'});
}
